<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>佣金规则</span>
        <el-button v-if="!hasFixedRule" type="primary" size="small" @click="openDialog()">新增规则</el-button>
      </div>
      <p class="page-tip">纳新佣金按固定金额结算，每个代理商推广注册成功后发放对应佣金。</p>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="ruleName" label="规则名称" min-width="160" />
        <el-table-column label="固定金额(元)" width="140">
          <template slot-scope="{ row }">¥{{ row.fixedAmount || 0 }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="{ row }">{{ labelOf(COMMON_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" min-width="160" />
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
            <el-button v-if="row.ruleType !== 'fixed'" type="text" size="small" class="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '编辑规则' : '新增规则'" :visible.sync="visible" width="420px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName" />
        </el-form-item>
        <el-form-item label="固定金额" prop="fixedAmount">
          <el-input-number v-model="form.fixedAmount" :min="0" :precision="2" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 100%">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommissionRules, saveCommissionRule, deleteCommissionRule } from '@/api/admin'
import { COMMON_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'

export default {
  name: 'AgentsCommission',
  data() {
    return {
      COMMON_STATUS,
      loading: false,
      list: [],
      visible: false,
      submitting: false,
      form: { id: null, ruleName: '', ruleType: 'fixed', fixedAmount: 0, status: 1 },
      rules: {
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        fixedAmount: [{ required: true, message: '请输入固定金额', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    },
    hasFixedRule() {
      return this.list.some(r => r.ruleType === 'fixed')
    }
  },
  created() {
    this.loadRules()
  },
  methods: {
    labelOf,
    async loadRules() {
      this.loading = true
      try {
        const rows = await getCommissionRules() || []
        this.list = rows.filter(r => r.ruleType === 'fixed')
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    openDialog(row) {
      this.form = row
        ? { ...row, ruleType: 'fixed' }
        : { id: null, ruleName: '', ruleType: 'fixed', fixedAmount: 0, status: 1 }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await saveCommissionRule({
            ...this.form,
            ruleType: 'fixed',
            rate: 0
          })
          this.$message.success('保存成功')
          this.visible = false
          this.loadRules()
        } catch (e) {
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该规则？', '提示', { type: 'warning' }).then(async () => {
        try {
          await deleteCommissionRule(row.id)
          this.$message.success('已删除')
          this.loadRules()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-tip {
  margin: 0 0 16px;
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}
.danger {
  color: #f56c6c;
}
</style>
